var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrochip = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5V16.5C4.5 18.1569 5.84315 19.5 7.5 19.5H16.5C18.1569 19.5 19.5 18.1569 19.5 16.5V7.5C19.5 5.84315 18.1569 4.5 16.5 4.5H7.5ZM7.5 6C6.67157 6 6 6.67157 6 7.5V16.5C6 17.3284 6.67157 18 7.5 18H16.5C17.3284 18 18 17.3284 18 16.5V7.5C18 6.67157 17.3284 6 16.5 6H7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.5C7.83579 7.5 7.5 7.83579 7.5 8.25V15.75C7.5 16.1642 7.83579 16.5 8.25 16.5H15.75C16.1642 16.5 16.5 16.1642 16.5 15.75V8.25C16.5 7.83579 16.1642 7.5 15.75 7.5H8.25ZM9.3 9C9.13431 9 9 9.13431 9 9.3V14.7C9 14.8657 9.13431 15 9.3 15H14.7C14.8657 15 15 14.8657 15 14.7V9.3C15 9.13431 14.8657 9 14.7 9H9.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5H9V4.5H7.5V1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.5H12.75V4.5H11.25V1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H16.5V4.5H15V1.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.5H9V22.5H7.5V19.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.5H12.75V22.5H11.25V19.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5H16.5V22.5H15V19.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.5V15H22.5V16.5H19.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.75V11.25H22.5V12.75H19.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9V7.5H22.5V9H19.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.5V15H4.5V16.5H1.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.75V11.25H4.5V12.75H1.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9V7.5H4.5V9H1.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrochip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microchip.1de12ffc3ff6f9c595d48beff2eaac45.svg";